import type { MCPRiskUnavailableReason } from '@kirin/api-client/contracts/mcp';

/** Why a row shows a dash instead of a risk value. */
export const MCP_RISK_UNAVAILABLE_COPY: Record<
  MCPRiskUnavailableReason,
  string
> = {
  remote: 'Not available for remote servers',
  local: 'Not available for local servers',
  gateway: 'Not available for gateway-managed servers',
  'no-record': 'No AgentMesh result for this version yet',
};
